import { alternateLocale, LOCALE_NAMES } from '@awj/i18n';

import { useI18n } from '~/i18n/index.tsx';

/**
 * One pill, two languages.
 *
 * The reference panel's LanguageSwitch: it sits beside icon-only tools in the command bar, so it
 * is built to the same height as those and gains only the width its label needs.
 *
 * The label is set in the OFFERED language rather than the current one, which is why it carries
 * its own `lang` — a reader who cannot read the language the panel is in has to be able to find
 * the way out of it.
 */
export function LocaleSwitch({ tone = 'light' }: { tone?: 'light' | 'dark' }) {
  const { locale, setLocale, t } = useI18n();
  const other = alternateLocale(locale);

  return (
    <button
      type="button"
      className={`langswitch langswitch--${tone}`}
      onClick={() => setLocale(other)}
      aria-label={t('common.language')}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="8.4" />
        <path d="M3.6 12h16.8" />
        <path d="M12 3.6c2.1 2.3 3.2 5.2 3.2 8.4s-1.1 6.1-3.2 8.4c-2.1-2.3-3.2-5.2-3.2-8.4S9.9 5.9 12 3.6z" />
      </svg>
      <span className="langswitch__label" lang={other} data-short={other.toUpperCase()}>
        {LOCALE_NAMES[other]}
      </span>
    </button>
  );
}
